import apiGetRequest from './base/api-get-request'
import { screenshotHeaders } from 'src/main_app/utils/screenshot-access'

const getCustomersDetailPublic = id =>
    apiGetRequest(`/customer/${id}/get-name-for-screenshot`)({ headers: screenshotHeaders() })

export default getCustomersDetailPublic
